import { CardGiftcard } from "@mui/icons-material";
import { Box, Divider, List, ListItem, ListSubheader, Stack, Typography } from "@mui/joy";
import { Outlet } from "@tanstack/react-router";
import { useState } from "react";

import { useVenueCreditSystemQuery } from "@/hooks/credits";
import { useCurrentVenueQuery } from "@/hooks/venues";

import { ListItemButtonLink } from "../Links";
import LoyaltyNavToggle, { LoyaltyNavContext } from "./LoyaltyNavToggle";

const LoyaltyNav = () => {
  const { data: venue } = useCurrentVenueQuery();
  const { data: creditSystem } = useVenueCreditSystemQuery(venue?.uuid);
  const baseUrl = "/gym/$venueUuid/loyalty";
  return (
    <List
      sx={{
        width: 200,
        flexShrink: 0,
        flexGrow: 0,
        backgroundColor: "neutral.100",
        borderLeft: "1px solid",
        borderRight: "1px solid",
        borderColor: "neutral.200",
        borderTopLeftRadius: 16,
        borderBottomLeftRadius: 16,
        overflow: "hidden",
        ".Mui-selected": {
          color: "var(--joy-palette-primary-blue2)",
          backgroundColor: "transparent!important",
          fontWeight: "bold!important",
        },
        "a:hover": {
          backgroundColor: "var(--joy-palette-primary-100)!important",
        },
        ".MuiListSubheader-root": {
          fontWeight: "bold",
          textTransform: "none",
          letterSpacing: "0",
          color: "neutral.600",
          fontSize: "14px",
        },
        ".MuiListItemButton-root": {
          fontWeight: "bold",
          fontSize: "16px",
        },
      }}
    >
      <ListItem sx={{ justifyContent: "space-between" }}>
        <Typography level="title-md" startDecorator={<CardGiftcard fontSize="small" />}>
          Loyalty
        </Typography>
        <LoyaltyNavToggle collapse />
      </ListItem>
      <Divider />
      {creditSystem?.name ? <ListSubheader>{creditSystem.name}</ListSubheader> : null}
      <ListItemButtonLink to="./quests" from={baseUrl} activeProps={{ selected: true }}>
        Quests
      </ListItemButtonLink>
      <ListItemButtonLink to="./rewards" from={baseUrl} activeProps={{ selected: true }}>
        Rewards
      </ListItemButtonLink>
      <ListItemButtonLink to="./accounts" from={baseUrl} activeProps={{ selected: true }}>
        Accounts
      </ListItemButtonLink>
      <Divider />
      {venue?.userRole === "ADMIN" ? (
        <ListItemButtonLink to="/gym/$venueUuid/settings/credits" from={baseUrl}>
          Credit settings
        </ListItemButtonLink>
      ) : null}
    </List>
  );
};

export default function Loyalty() {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <LoyaltyNavContext.Provider value={{ isExpanded, setIsExpanded }}>
      <Stack direction="row" sx={{ height: "100dvh" }}>
        <Box
          component="nav"
          id="loyalty-navigation"
          aria-label="Loyalty"
          aria-hidden={!isExpanded}
          sx={{
            display: "flex",
            flexShrink: 0,
            width: isExpanded ? 200 : 0,
            overflow: "hidden",
            visibility: isExpanded ? "visible" : "hidden",
            transition: isExpanded ? "width 0.3s, visibility 0s" : "width 0.3s, visibility 0s 0.3s",
            "@media (prefers-reduced-motion: reduce)": {
              transition: "none",
            },
          }}
        >
          <LoyaltyNav />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Outlet />
        </Box>
      </Stack>
    </LoyaltyNavContext.Provider>
  );
}
